import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalStyles from './components/GlobalStyles';
import Nav from './components/Nav';
import Footer from './components/Footer';
import HeroSection from './components/sections/HeroSection';
import AnalysisSection from './components/sections/AnalysisSection';
import TestingSection from './components/sections/TestingSection';
import StylesSection from './components/sections/StylesSection';
import EditorSection from './components/sections/EditorSection';
import AnimationSection from './components/sections/AnimationSection';
import WatermarkSection from './components/sections/WatermarkSection';
import DownloadSection from './components/sections/DownloadSection';
import CTASection from './components/sections/CTASection';

const HomePage = () => {
  return (
    <main className="pt-24 pb-20 overflow-hidden">
      <HeroSection />
      <AnalysisSection />
      <TestingSection />
      <StylesSection />
      <EditorSection />
      <AnimationSection />
      <WatermarkSection />
      <DownloadSection />
      <CTASection />
    </main>
  );
};

const App = () => {
  return (
    <Router basename="/">
      <div className="w-full min-h-screen" style={{ backgroundColor: '#F4F1EA', color: '#1F1F1F', fontFamily: "'DM Sans', sans-serif" }}>
        <GlobalStyles />
        <div className="bg-noise"></div>
        <svg className="absolute w-0 h-0">
          <filter id="wavy">
            <feTurbulence x="0" y="0" baseFrequency="0.02" numOctaves="5" seed="2"></feTurbulence>
            <feDisplacementMap in="SourceGraphic" scale="2"></feDisplacementMap>
          </filter>
        </svg>
        <Nav />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
